export default __webpack_public_path__ + "static/media/go_to_market_module_preview.b306650f.png";